<template>
  <v-container fluid>
    <div class="wrapper" id="wrapper">
      <!-- Existing content, remove Save button -->
      <img id="first" :src="`${baseUrl}/pdfs/images/1_new.jpg`" />
      <img id="tenth" :src="`${baseUrl}/pdfs/images/11.jpg`" />
      <img id="eleventh" :src="`${baseUrl}/pdfs/images/2_new.jpg`" />
      <img id="second" :src="`${baseUrl}/pdfs/images/3.jpg`" />
      <img id="third" :src="`${baseUrl}/pdfs/images/4.jpg`" />
      <img id="fourth" :src="`${baseUrl}/pdfs/images/5_new.jpg`" />
      <img id="fifth" :src="`${baseUrl}/pdfs/images/6.jpg`" />
      <img id="sixth" :src="`${baseUrl}/pdfs/images/7_new.jpg`" />
      <img id="seventh" :src="`${baseUrl}/pdfs/images/9.jpg`" />
      <img id="eight" :src="`${baseUrl}/pdfs/images/8.jpg`" />
      <img id="ninth" :src="`${baseUrl}/pdfs/images/10_new.jpg`" />
      <canvas
        id="signature-pad"
        class="signature-pad"
        :width="width"
        :height="height"
      ></canvas>
    </div>
      <img id="twelveth" :src="`${baseUrl}/pdfs/images/13.jpg`" />

    <!-- Show email dialog button -->
    <v-btn @click="promptForEmailAndSave" color="primary">Save</v-btn>

    <!-- Email input dialog -->
    <v-dialog v-model="emailDialog" persistent>
      <v-card>
        <v-card-title>
          Send to an email address
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="userEmail"
            label="Email"
            required
          ></v-text-field>
          <v-text-field
            v-model="userPhone"
            label="Phone"
            required
          ></v-text-field>
          <!-- Added phone field -->
          <v-text-field
            v-model="userBusinessName"
            label="Business Name"
            required
          ></v-text-field>
          <!-- Added business_name field -->
        </v-card-text>
        <v-card-actions>
          <v-btn @click="saveSignatureWithEmail" color="primary">OK</v-btn>
          <v-btn @click="cancelSignatureSave" color="error">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="5000" bottom :color="snackbarColor">
      {{ snackbarMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
import SignaturePad from 'signature_pad'
import axios from 'axios'

export default {
  props: ['draw'],
  data() {
    return {
      baseUrl: 'https://www.bluebusinessguide.com.au',
      height: 0,
      width: 0,
      signaturePad: null,
      pendingDummy: false,
      pendingDummyPayload: null,
      pendingDummyCapture: false,
      emailDialog: false,
      userEmail: '',
      userPhone: '', // Added userPhone property
      userBusinessName: '',
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: ''
    }
  },

  mounted() {
    this.emitInterface()

    setTimeout(() => {
      let box = document.getElementById('wrapper')
      this.height = box.clientHeight
      this.width = box.clientWidth

      this.signaturePad = new SignaturePad(
        document.getElementById('signature-pad'),
        {
          backgroundColor: 'rgba(255, 255, 255, 0)',
          penColor: 'rgb(0, 0, 0)',
          minWidth: 0.7,
          maxWidth: 1.8,
          velocityFilterWeight: 0.6,
          throttle: 12,
          minDistance: 2
        }
      )

      if (this.pendingDummy) {
        this.pendingDummy = false
        const payload = this.pendingDummyPayload || {}
        const shouldCapture = this.pendingDummyCapture
        this.pendingDummyPayload = null
        this.pendingDummyCapture = false
        this.applyDummyWriting(payload)
        if (shouldCapture) {
          this.save({ silent: true, clearOnEmpty: false })
        }
      }
    }, 1000)
  },

  methods: {
    promptForEmailAndSave() {
      // Show the email input dialog
      this.emailDialog = true
    },

    async saveSignatureWithEmail() {
      // Close the email input dialog
      this.emailDialog = false

      // Validate the email, phone, and business_name
      if (!this.userEmail || !this.userPhone || !this.userBusinessName) {
        return alert('Email, Phone, and Business Name are required.')
      }

      // Save the signature with the provided values
      if (this.signaturePad.isEmpty()) {
        return alert('Please provide a drafting first.')
      }

      const data = document
        .getElementById('signature-pad')
        .toDataURL('image/png')

      try {
        // Make an API call to save the signature with the provided values
        const response = await axios.post('/api/admin/images', {
          email: this.userEmail,
          phone: this.userPhone, // Added phone value
          business_name: this.userBusinessName, // Added business_name value
          img: data
        })

        this.$store.dispatch({ type: 'setImg', value: response.data.img })
        this.snackbarMessage = 'Draft saved successfully!'
        this.snackbarColor = 'success' // Set color to green for success
        this.snackbar = true
      } catch (error) {
        console.error('Error saving signature:', error)
        this.snackbarMessage = 'Error saving signature. Please try again.'
        this.snackbarColor = 'error' // Set color to red for error
        this.snackbar = true
      }
    },

    cancelSignatureSave() {
      this.emailDialog = false
    },

    save(options = {}) {
      const { silent = false, clearOnEmpty = true } = options
      if (!this.signaturePad || this.signaturePad.isEmpty()) {
        if (clearOnEmpty) {
          this.$store.dispatch({ type: 'setImg', value: '' })
        }
        if (!silent) {
          return alert('Please provide a signature first.')
        }
        return false
      }
      let data = document.getElementById('signature-pad').toDataURL('image/png')
      this.$store.dispatch({ type: 'setImg', value: data })
      return true
    },
    applyDummyWriting(payload = {}) {
      const captureAfter = payload.captureAfter === true
      if (!this.signaturePad) {
        this.pendingDummy = true
        this.pendingDummyPayload = payload
        this.pendingDummyCapture = captureAfter
        return
      }

      const title = payload.title || 'Demo Contract'
      const seedOffset = payload.seedOffset || 0
      const jitter = () => (Math.random() - 0.5) * (8 + seedOffset)

      const target = this.signaturePad.canvas
      const canvas = document.createElement('canvas')
      canvas.width = target.width
      canvas.height = target.height

      const ctx = canvas.getContext('2d')
      if (!ctx) {
        return
      }

      const fontSize = Math.max(Math.round(canvas.width / 25), 24)
      ctx.fillStyle = '#000'
      ctx.strokeStyle = '#000'
      ctx.lineWidth = Math.max(Math.round(canvas.width / 600), 2)
      ctx.font = `${fontSize}px sans-serif`

      const titleX = Math.round(canvas.width * 0.05 + jitter())
      const titleY = Math.round(canvas.height * 0.1 + jitter())
      ctx.fillText(title, titleX, titleY)

      ctx.beginPath()
      ctx.moveTo(titleX, titleY + fontSize * 0.6 + jitter())
      ctx.bezierCurveTo(
        titleX + canvas.width * 0.2 + jitter(),
        titleY + fontSize * 1.2 + jitter(),
        titleX + canvas.width * 0.4 + jitter(),
        titleY + fontSize * 0.2 + jitter(),
        titleX + canvas.width * 0.6 + jitter(),
        titleY + fontSize * 0.8 + jitter()
      )
      ctx.stroke()

      const sigY = Math.round(canvas.height * 0.85 + jitter())
      ctx.beginPath()
      ctx.moveTo(canvas.width * 0.55 + jitter(), sigY + jitter())
      ctx.bezierCurveTo(
        canvas.width * 0.6 + jitter(),
        sigY - 30 + jitter(),
        canvas.width * 0.7 + jitter(),
        sigY + 20 + jitter(),
        canvas.width * 0.8 + jitter(),
        sigY - 10 + jitter()
      )
      ctx.stroke()

      const dataUrl = canvas.toDataURL('image/png')
      this.signaturePad.clear()
      this.signaturePad.fromDataURL(dataUrl)
      if (captureAfter) {
        this.save({ silent: true, clearOnEmpty: false })
      }
    },
    clearPad() {
      if (this.signaturePad) {
        this.signaturePad.clear()
      }
      this.$store.dispatch({ type: 'setImg', value: '' })
    },

    drawIn(val) {
      // Kept for reference
      if (val == 'destination-out') {
        let data = this.signaturePad.toData()
        if (data) {
          data.pop() // remove the last dot or line
          this.signaturePad.fromData(data)
        }
      } else {
        let ctx = document.getElementById('signature-pad').getContext('2d')
        console.log(ctx.globalCompositeOperation)
        ctx.globalCompositeOperation = val // default value
      }
    },

    emitInterface() {
      this.$emit('interface', {
        save: () => this.save(),
        capture: () => this.save({ silent: true, clearOnEmpty: true }),
        drawIn: val => this.drawIn(val),
        applyDummyWriting: () => this.applyDummyWriting(),
        clear: () => this.clearPad()
      })
    }
  }
}
</script>

<style>
/* Add any custom styles for existing elements or the dialog here */

#firstImage {
  background-image: url('https://bluebusinessguide.com.au/pdfs/images/1.jpg');
  width: 500px;
  height: 1000px;
}

.wrapper {
  position: relative;
  width: 100%;
}

img {
  position: relative;
  left: 0;
  top: 0;
  width: inherit;
}

.signature-pad {
  position: absolute;
  left: 0;
  top: 0;
  touch-action: none;
}
</style>
